import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import ServiceLines from "../components/site/ServiceLines";
import ResearchCard from "../components/site/ResearchCard";
import Marquee from "../components/site/Marquee";
import Workflow from "../components/site/Workflow";
import Comparison from "../components/site/Comparison";
import Revenue from "../components/site/Revenue";
import ROICalculator from "../components/site/ROICalculator";
import WhyMedlyn from "../components/site/WhyMedlyn";
import Founders from "../components/site/Founders";
import FAQ from "../components/site/FAQ";
import FinalCTA from "../components/site/FinalCTA";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

const Home = () => (
  <main>
    <Navbar />
    <Hero />
    <ServiceLines />
    <ResearchCard />
    <Marquee />
    <Workflow />
    <Comparison />
    <Revenue />
    <ROICalculator />
    <WhyMedlyn />
    <Founders />
    <FAQ />
    <FinalCTA />
    <Contact />
    <Footer />
  </main>
);
export default Home;
